module.exports = __webpack_public_path__ + "static/img/yytx38.eecd55f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx38.png
// module id = 905
// module chunks = 0